<!--
일반검수 레이아웃 (24년 5월버전) >
일괄기능-컨트롤러
------------------------------------

-->
<template>
    <div class="house-header uk-flex uk-flex-between uk-flex-middle">
        <div>
            <app-batch-all-item-checker :items="batch.items" title="전체선택" :disabled="disableCheckbox"></app-batch-all-item-checker>
        </div>


        <div class="checked-amount" :class="selectedClass">
            SELECTED QTY
            <span class="amount">{{ selectedQty }}</span>
            개
        </div>

        <!-- 정상버튼 -->
        <button
            v-show="itemCheckedCount > 0"
            class="uk-button uk-button-primary ok-button"
            @click="$refs.ok.setOk()"
        >
            <i class="material-icons">check</i>
            정상
        </button>

        <!-- 컴포넌트 -->
        <batch-ok
            ref="ok"
            :csrf-token="csrfToken"
            :prod-ids="checkedProdIds"
            :selected-qty="selectedQty"

            @check:exception="msg => $emit('check:exception', msg)"
            @done:pack="house_id => $emit('done:pack', house_id)"
            @done:ready="$emit('done:ready')"
        >
        </batch-ok>


        <div class="total-amount" >
            TOTAL QTY
            <span class="amount">{{ totalAmount }}</span>
            개
        </div>

        <!-- 포장방법 -->
        <div class="pack-type" :class="packTypeClass">
            <div class="badge">
                <i class="material-icons">star</i>
                {{ packTypeText }}
            </div>
        </div>

        <!-- 안정포장 -->
        <div class="safety-pack-type" :class="safetyPackTypeClass">
            <div class="badge">
                <i class="material-icons">star</i>
                {{ safetyPackTypeText }}
            </div>
        </div>

        <!-- 포장요청사항 -->
        <div class="pack-request" :class="packRequestClass">
            <div class="badge">
                <i class="material-icons">star</i>
                {{ packRequestText }}

                <div
                    class="tooltip"
                    v-html="houseGroup.pack_request ? houseGroup.pack_request.replace(/(?:\r\n|\r|\n)/g, '<br />') : null"
                >
                </div>
            </div>
        </div>

        <div class="uk-width-expand">
        </div>

        <div class="house-name">
            {{ houseName }}
        </div>
        <div class="house-code">
            <a class="uk-link-reset" :href="'/houses/'+houseId+'/first-prod?tab=house-prod-info'" target="_blank" title="상세페이지">
                {{ houseCode }}
            </a>
        </div>


    </div>
</template>

<script>
    import checkedCountable from '../../../../batch/checked-countable';

    export default {
        mixins: [
            checkedCountable,
        ],
        components: {
            'batch-ok': require('./batch-ok.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            // 총 수량
            totalAmount: Number,

            // 수취인
            houseName: String,

            // 하우스ID
            houseId: Number,

            // 배송코드
            houseCode: String,

            /**
             * 일괄검수용 하우스그룹 객체
             */
            houseGroup: {
                type: Object,
                default: null,
            },

            /**
             * 체크박스 disable 여부
             */
            disableCheckbox: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
            };
        },
        computed: {
            /**
             * 선택된 수량합계
             * @return array
             */
            selectedQty() {
                // 선택 된 아이템만 필터
                return _.sumBy(this.checkedItems, 'amount');
            },

            /**
             * 선택 관련 클래스
             * @return object
             */
            selectedClass() {
                return {
                    selected: this.itemChecked
                };
            },

            /**
             * 선택된 상품번호배열
             * @return array
             */
            checkedProdIds() {
                // 선택 된 아이템만 필터
                return _.map(this.checkedItems, 'id');
            },


            /**
             * 포장방법
             * @return string
             */
            packTypeText() {
                return this.houseGroup.pack_type === 0
                    ? '포장방법(작업자임의)'
                    : this.houseGroup.pack_type_text;
            },

            /**
             * 안전포장
             * @return string
             */
            safetyPackTypeText() {
                return this.houseGroup.safety_pack_type === 0
                    ? '안전포장(작업자임의)'
                    : this.houseGroup.safety_pack_type_text;
            },

            /**
             * 포장요청
             * @return string
             */
            packRequestText() {
                return this.houseGroup.pack_request ? '포장요청(있음)' : '포장요청(없음)';
            },


            /**
             * 포장방법 클래스
             * @return object
             */
            packTypeClass() {
                return {
                    'on': this.houseGroup.pack_type && this.houseGroup.pack_type !== 0,
                };
            },

            /**
             * 안전포장 클래스
             * @return object
             */
            safetyPackTypeClass() {
                return {
                    'on': this.houseGroup.safety_pack_type && this.houseGroup.safety_pack_type !== 0,
                };
            },

            /**
             * 포장요청사항 클래스
             * @return object
             */
            packRequestClass() {
                return {
                    'on': (!! this.houseGroup.pack_request),
                };
            },
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>

    .house-header {
        padding: 5px;
        background-color: #333;
        color: #fff;
        //border-bottom: 1px solid #999;

        position: -webkit-sticky;
        position: sticky;
        top: 0;

        .uk-checkbox {
            margin-top: 0;
            width: 1.5rem;
            height: 1.5rem;
            background-color: #fff;
            margin-left: 0.25rem;
            margin-right: 1rem;

            &:checked, &:indeterminate {
                background-color: #1e87f0;
            }
        }

        .checked-amount {
            margin-right: 10px;
            .amount {
                font-size: 1.5rem;
                color: #eee;

            }

            &.selected .amount {
                color: #FFFD7C !important;
            }
        }

        .total-amount {
            margin-left: 20px;
            .amount {
                font-size: 1.5rem;
                //color: #999;
            }
        }


        // 포장방법, 안전포장, 포장요청
        .pack-type, .safety-pack-type, .pack-request {
            margin-left: 1rem;
            //width: 170px;

            .badge {
                display: none; // off 일때 아예 노출안함

            }
            .material-icons {
                display: none;
            }

            &.pack-type {
                margin-left: 4rem;
            }

            // 켜짐
            &.on .badge{
                display: inline-block;

                border-radius: 40px;
                padding: 5px 20px;
                background-color: #fff;
                color: #000;
                .material-icons {
                    //display: inline-block;
                    color: #1e87f0 !important;
                    font-size: 1.5rem;
                    vertical-align: bottom;
                }
            }

            // 안전포장 켜짐
            &.safety-pack-type.on .badge {
                //background-color: #002060 !important;
                //color: #fff !important;
            }

            // 포장요청 켜짐
            &.pack-request.on .badge {
                //background-color: #ff0 !important;
                //color: #fff !important;
            }

            // 포장요청 툴팁
            &.pack-request .badge {
                position: relative;
                .tooltip {
                    display: none;
                    position: absolute;

                    top: 0;
                    left: 110px;


                    border: 1px solid #999;
                    box-shadow: 2px 2px 2px #c3cee0;
                    padding: 5px;

                    width: 300px;

                    background-color: #ffffdd;
                    color: #000;

                }

                &:hover .tooltip {
                    display: block;
                }
            }

        }

        .house-name {
            margin-right: 1rem;
        }
        .house-code {
            color: #FFFD7C;
            margin-right: 2rem;
        }

        .ok-button {
            font-size: 1rem;
            .material-icons {
                font-size: 1.5rem;
            }
        }
    }


</style>